import React, { Component } from 'react';
import uploadcare from 'uploadcare-widget';
import config from 'config';

uploadcare.start({ publicKey: config.uploadcare.key });

class Uploader extends Component {
  static defaultProps = {
    'data-multiple': false,
  };

  componentDidMount() {
    const widget = uploadcare.Widget(this.uploader);
    this.widget = widget;
    const { value, onChange, onUploadComplete } = this.props;

    if (typeof value !== 'undefined') {
      widget.value(value);
    }
    if (typeof onChange === 'function') {
      widget.onChange(onChange);
    }
    if (typeof onUploadComplete === 'function') {
      widget.onUploadComplete(onUploadComplete);
    }
  }

  getInputAttributes() {
    const attributes = Object.assign({}, this.props);

    delete attributes.value;
    delete attributes.onChange;
    delete attributes.onUploadComplete;

    attributes['data-images-only'] = true;
    attributes['data-public-key'] = config.uploadcare.key;
    attributes['data-cdn-base'] = config.images.url;
    attributes['data-clearable'] = true;

    return attributes;
  }

  show() {
    this.widget.openDialog();
  }

  render() {
    const attributes = this.getInputAttributes();
    return (
      <input
        type="hidden"
        ref={input => {
          this.uploader = input;
        }}
        {...attributes}
      />
    );
  }
}

export default Uploader;
